module.exports = __webpack_public_path__ + "static/to-explain-the-world-d98df734c8bf8a175b31f95a78c56d33.jpg";